<template>
    <div>
        <Modal
            v-model="customerExcelShow"
            :closable="false"
            :mask-closable="false"
            :title="excelTitle">
            <div v-if="excelSteps == 1">
                <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
                    <FormItem label="接收邮箱" prop="mail">
                        <Input v-model="formValidate.mail" placeholder="请输入接收邮箱" @keydown.native.enter.prevent="handleSubmit('formValidate')"></Input>
                    </FormItem>
                    <FormItem label="导出" prop="value">
                        <RadioGroup v-model="formValidate.value">
                            <Radio label="1">按筛选条件导出</Radio>
                            <Radio label="2">导出所有数据</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="录入顺序" prop="channel_info_sort" v-if="excelTitle == '导出客户Excel'">
                        <RadioGroup v-model="formValidate.channel_info_sort">
                            <Radio label="asc">正序</Radio>
                            <Radio label="desc">倒序</Radio>
                        </RadioGroup>
                    </FormItem>
                </Form>
            </div>
            <div v-if="excelSteps == 2">
                <div>点击下方链接下载：</div>
                <a :href="downloadLink">{{downloadLink}}</a>
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="customerExcelClose">取消</Button>
                <Button type="primary" size="large" @click="handleSubmit('formValidate')" v-if="excelSteps == 2 ? false : true">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:"CRM_customerExcel",
    props:['customerExcelShow','excelTitle','excelSteps','downloadLink'],
    data(){
        return{
            formValidate:{
                mail:'',
                value:'1',
                channel_info_sort:"asc"
            },
            ruleValidate: {
                mail: [
                    { required: true, message: '请输入接收邮箱', trigger: 'blur' },
                    { type: 'email', message: '接收邮箱格式错误', trigger: 'blur' }
                ],
                value: [
                    { required: true, message: '', trigger: 'change' }
                ],
                channel_info_sort: [
                    { required: true, message: '', trigger: 'change' }
                ],
            }
        }
    },
    methods:{
        //关闭导出客户客户Excel模态框
        customerExcelClose(){
            this.$emit('customerExcelEven',false)
        },
        //确认导出客户客户Excel模态框
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    localStorage.setItem("email",this.formValidate.mail);
                    this.$emit('customerExcelEven',false,true,this.formValidate,this.excelTitle)
                } else {
                    this.$Message.error('请输入邮箱');
                }
            })
        }
    },
    watch:{
        customerExcelShow(val){
            if(val){
                let getStorageEmall = localStorage.getItem("email")
                if(getStorageEmall){
                    this.formValidate.mail = getStorageEmall
                }
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/commonTmp/CRM/CRM_customerExcel.vue